<template>
  <div
    @click="thisComponentClick"
    :style="{ 'margin': '1px' }"
    :class="{ active: active }"
  >
    <div
      class="header"
      :style="{ 'background-color': penProps.lineColor, 'width': '20px', height: '20px' }"
    ></div>
    {{penProps.name}}
    {{penProps.lineWidth}}px
  </div>
</template>

<script lang="">
export default {
  // Options / Data
  data () {
    return {}
  },
  props    : [ 'penProps', 'active' ],
  computed : {},
  methods  : {
    thisComponentClick () {
      this.$emit('click', this.penProps.id)
    }
  }// ,
  // watch: {},
  // Options / DOM
  // el () {},
  // replace: true,
  // template: '',
  // Options / Lifecycle Hooks
  // init () {},
  // crated () {},
  // beforeCompile () {},
  // compiled () {},
  // ready () {},
  // attached () {},
  // detached () {},
  // beforeDestroy () {},
  // destroyed () {},
  // Options / Assets
  // directives: {},
  // elementDirectives: {},
  // filters: {},
  // components: {},
  // transitions: {},
  // partials: {},
  // Options / Misc
  // parent: null,
  // events: {},
  // mixins: [],
  // name: ''
}
</script>

<style scoped>
.active {
  background-color: white;
}
.header {
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/canvas/controller/penProperty-penSelector.vue